import {NgModule}                            from '@angular/core';
import {CommonModule}                        from '@angular/common';
import {SnackbarService}                     from './services/snackbar.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {SharedModule}                        from '../shared/shared.module';
import {AuthInterceptor}                     from './interceptors/auth.interceptor';
import {UriInterceptor}                      from './interceptors/uri.interceptor';
import {ErrorInterceptor}                    from './interceptors/error.interceptor';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule
  ],
  providers: [
    SnackbarService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: UriInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
  ]
})
export class CoreModule {
}
